<div class="footer_container">
  <div class="flex_between container footer_container--top tablet_width h_100">
    <div class="flex_column_between tablet_social_follow w_20">
      <div>
        <img src="assets/images/new_logo.svg">
        <div class="mt_20 text_normal_sub marketplace_for_sales">
          Маркетплейс по продаже цветов, букетов, игрушек, десертов, тортов и подарков
        </div>
      </div>
      <div class="social-follow text_normal">
        <div class="social-follow--text">
          Следи за нами в соц сетях!
        </div>
        <div class="flex_align_center social-follow--icons mt_16">
          <div class="telegram_button pointer" (click)="navigateTpSocialLink('telegram')">
            <svg fill="currentColor" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 0C8.0595 0 0 8.0595 0 18C0 27.9405 8.0595 36 18 36C27.9405 36 36 27.9405 36 18C36 8.0595 27.9405 0 18 0ZM26.343 12.2415C26.073 15.087 24.9 21.9945 24.3045 25.182C24.0525 26.532 23.5545 26.9835 23.0745 27.027C22.029 27.123 21.2355 26.3355 20.223 25.6725C18.639 24.6345 17.7435 23.988 16.206 22.974C14.4285 21.8025 15.5805 21.159 16.593 20.1075C16.8585 19.8315 21.4635 15.642 21.5535 15.2625C21.564 15.2145 21.576 15.0375 21.4695 14.9445C21.363 14.8515 21.2085 14.883 21.0975 14.9085C20.9385 14.9445 18.408 16.617 13.5045 19.926C12.786 20.4195 12.135 20.6595 11.5515 20.6475C10.9095 20.634 9.6735 20.2845 8.754 19.9845C7.6275 19.6185 6.7305 19.4235 6.8085 18.8025C6.849 18.4785 7.2945 18.147 8.1465 17.808C13.3935 15.522 16.893 14.0145 18.6435 13.2855C23.643 11.2065 24.681 10.845 25.359 10.833C26.208 10.821 26.412 11.5215 26.343 12.2415Z"/>
            </svg>
          </div>
          <div class="ml_20 vk_button pointer" (click)="navigateTpSocialLink('vk')">
            <svg fill="currentColor" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.474 2.526C30.948 0 26.8815 0 18.75 0H17.25C9.1185 0 5.052 0 2.526 2.526C0 5.052 0 9.1185
            0 17.25V18.75C0 26.8815 0 30.9465 2.526 33.474C5.052 36.0015 9.1185 36 17.25 36H18.75C26.8815 36 30.9465 36
            33.474 33.474C36 30.948 36 26.8815 36 18.75V17.25C36 9.1185 36 5.052 33.474 2.526ZM29.2545 25.5H26.6295C25.629
            25.5 25.335 24.702 23.5545 22.9215C21.996 21.42 21.3285 21.225 20.94 21.225C20.4105 21.225 20.253 21.375 20.253
            22.125V24.4785C20.253 25.1235 20.0475 25.5 18.378 25.5C15.597 25.5 12.54 23.811 10.3695 20.697C7.1145 16.1355 6.225 12.687 6.225 11.9925C6.225 11.6025 6.375 11.25 7.125 11.25H9.7515C10.422 11.25 10.674 11.544 10.926 12.27C12.21 16.0095 14.376 19.278 15.2655 19.278C15.5985 19.278 15.7515 19.1235 15.7515 18.2775V14.412C15.654 12.633 14.7075 12.486 14.7075 11.853C14.7075 11.5605 14.958 11.25 15.375 11.25H19.5015C20.058 11.25 20.2515 11.547 20.2515 12.2145V17.415C20.2515 17.97 20.493 18.165 20.6595 18.165C20.994 18.165 21.2715 17.97 21.8835 17.358C23.775 15.2445 25.11 11.991 25.11 11.991C25.278 11.601 25.584 11.2485 26.253 11.2485H28.878C29.6715 11.2485 29.8395 11.6565 29.6715 12.213C29.337 13.743 26.139 18.2475 26.139 18.2475C25.86 18.693 25.749 18.915 26.139 19.416C26.418 19.806 27.3345 20.5845 27.9465 21.3075C29.0745 22.5765 29.925 23.646 30.162 24.384C30.381 25.125 30.0045 25.5 29.2545 25.5Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="flex_between footer_popular_and_faq">
<!--      <div class="category_and_faq_list">-->
<!--        <div class="category_and_faq_list&#45;&#45;tooltip text_normal_sub bold_600">-->
<!--          {{'footer.populars._' | translate}}-->
<!--        </div>-->
<!--        <div class="category_and_faq_list&#45;&#45;links">-->
<!--          <div class="category_and_faq_list&#45;&#45;item text_normal pointer"-->
<!--               *ngFor="let item of popularsItems let i = index;"-->
<!--          >-->
<!--            {{('footer.populars.' + item.text) | translate}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="category_and_faq_list ml_32">-->
<!--        <div class="category_and_faq_list&#45;&#45;tooltip text_normal_sub bold_600">-->
<!--          {{'footer.faq._' | translate}}-->
<!--        </div>-->
<!--        <div class="category_and_faq_list&#45;&#45;links">-->
<!--          <div class="category_and_faq_list&#45;&#45;item text_normal pointer"-->
<!--               *ngFor="let item of frequentlyAskedQuestionsItems let i = index;"-->
<!--          >-->
<!--            {{('footer.faq.' + item.text) | translate}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="mobile_application">
      <div class="mobile_application--title text_normal_sub bold_600"
      >{{'footer.mobile_application' | translate}}</div>
      <div class="mobile_application--sub_title text_normal"
      >{{'footer.download_and_enjoy_all_features' | translate}}</div>
      <div class="mobile_application--sub_title_for_mobile text_normal_sub"
      >{{'footer.download_and_enjoy_all_features_for_mobile' | translate}}</div>
      <div class="mt_24 qr_and_application w_100">
        <app-application-svg></app-application-svg>
        <img class="qr_code" src="assets/images/icons/footer/qr.svg">
      </div>
    </div>
  </div>
  <div class="footer_container--bottom container flex_between_align_center">
    <div class="copyright text_normal">
      © Click Market 2024
    </div>
    <div class="footer-legal text_normal">
      <span class="footer-legal__item pointer" (click)="navigateToPrivacyPolicyPage()">{{'footer.terms_of_use' | translate}}</span>
      <span class="footer-legal__item pointer" (click)="navigateToPrivacyPolicyPage()">{{'footer.privacy_policy' | translate}}</span>
    </div>
  </div>
</div>
